import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { DateTime } from 'luxon';
import {
    faCalendarAlt,
    faCheckCircle,
    faCheckSquare,
    faCircle,
    faComment,
    faComments,
    faDotCircle,
    faEdit,
    faEnvelope,
    faEye,
    faKey,
    faNotesMedical,
    faPencilAlt,
    faPills,
    faPlusCircle,
    faShieldAlt,
    faSpellCheck,
    faSquare,
    faStickyNote,
    faSyringe,
    faTimes,
    faTrashAlt,
    faUsers,
    faUserSecret,
    faAngleUp,
    faAngleDown,
} from '@fortawesome/free-solid-svg-icons';

import { faApple, faAndroid } from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vuelidate from 'vuelidate';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import VModal from 'vue-js-modal';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './scss/main.scss';
import PageTitle from './components/PageTitle.vue';

// import('moment-timezone');

window.DateTime = DateTime;

window.moment = moment;

const options = {
    toast: {
        position: SnotifyPosition.rightTop,
    },
};

Vue.component('PageTitle', PageTitle);

Vue.use(Vuelidate);
Vue.use(Snotify, options);

library.add(
    faAndroid,
    faApple,
    faCalendarAlt,
    faCheckCircle,
    faCheckSquare,
    faCircle,
    faComment,
    faComments,
    faDotCircle,
    faEdit,
    faEnvelope,
    faEye,
    faKey,
    faNotesMedical,
    faPencilAlt,
    faPills,
    faPlusCircle,
    faShieldAlt,
    faSpellCheck,
    faSquare,
    faStickyNote,
    faSyringe,
    faTimes,
    faTrashAlt,
    faUsers,
    faUserSecret,
    faAngleUp,
    faAngleDown,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(VModal, { dialog: true });

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
